import { asyncAction } from 'lib/actionCreators'

export const HMList = asyncAction('recruiter/HM_LIST')
